<template>
    <div class="card card-transparent card-rounded">
        <div class="card-header">
            <therapist-dash-date-picker
                @newDatePicked="onNewDatePicked"
                @toggleDayOrWeek="toggleDayOrWeek"
                :route_refresh_calendar="part.route_refresh_calendar"
                :do_refresh="do_refresh">

            </therapist-dash-date-picker>
        </div>

        <div class="card-body">
            <div class="row">
                <div class="col">
                    <therapist-dash-expenditures-list
                            :route_expenditures="part.route_expenditures"
                            :date="pickedDate"
                            :do_refresh="do_refresh">

                    </therapist-dash-expenditures-list>
                </div>
            </div>
        </div>

        <hr class="m-0">

        <div class="card-body">

            <therapist-dash-schedules-table
                v-if="!showWeeklySchedule"
                :route_bookings="part.route_bookings"
                :date="pickedDate"
                :show_daily="!showWeeklySchedule"
                :do_refresh="do_refresh"
                v-on:new-schedules="handleNewSchedules">

            </therapist-dash-schedules-table>

            <therapist-dash-weekly-schedule v-else
                :route_weekly="part.route_weekly"
                :date="pickedDate"
                :do_refresh="do_refresh">

            </therapist-dash-weekly-schedule>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['part', 'do_refresh'],
        name: "therapist-dash-schedule",
        data: function () {
            return {
                pickedDate: new Date(),
                showWeeklySchedule: false,
            }
        },
        methods: {
            onNewDatePicked: function (newDate) {
                this.pickedDate = newDate;
            },
            toggleDayOrWeek: function (newValue) {
                // newValue === false => show daily schedule, else show weekly
                this.showWeeklySchedule = newValue;
            },
            handleNewSchedules (newSchedules) {

            }
        }
    }
</script>

<style scoped>

</style>